module.exports = __webpack_public_path__ + "img/search-white-icon.5749d264.svg";